// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1wxLB","top":"styles_top__2skIz","left":"styles_left__3HP3S","description":"styles_description__1kPqQ"};